import { useEffect, useState } from 'react';
import { fetchInvoicePreview, recordCustomerQuoteAcceptance, lockInvoiceV2 } from '../models/paymentsV2Model';
import { capability } from '../utilities/paymentPresentation';
import { usePaymentCommand } from './usePaymentCommand';
import { useAccess } from '../../../features/access/context/AccessProvider';
export function useInvoiceStep(queryPk, projection, reload) {
  const [preview, setPreview] = useState(null);
  const [previewError, setPreviewError] = useState(null);
  const acceptance = capability(projection, 'can_record_acceptance');
  const locking = capability(projection, 'can_lock_invoice');
  const { can } = useAccess();
  const canLockOnAcceptance = can('payments.lock_invoice');
  const acceptCommand = usePaymentCommand(`accept-${queryPk}`, () => reload({ silent: true }));
  const lockCommand = usePaymentCommand(`lock-${queryPk}`, () => reload({ silent: true }));
  const command = acceptance.allowed ? acceptCommand : lockCommand;
  useEffect(() => {
    let active = true;
    if (acceptance.allowed || locking.allowed) fetchInvoicePreview(queryPk).then(next => { if (active) setPreview(next); }).catch(error => { if (active) setPreviewError(error); });
    return () => { active = false; };
  }, [queryPk, acceptance.allowed, locking.allowed]);
  return { preview, previewError, acceptance, locking, canLockOnAcceptance, ...command,
    accept: () => acceptCommand.submit(payload => recordCustomerQuoteAcceptance(queryPk, payload), { lock_invoice: canLockOnAcceptance }),
    lock: () => lockCommand.submit(payload => lockInvoiceV2(queryPk, payload), {}) };
}
